import CheckOutContainer from "../../../../Components/Applications/Ecommerce/CheckOut/CheckOutContainer";

const CheckOut = () => {
  return <CheckOutContainer />;
};

export default CheckOut;
